import { useEffect } from "react"
import { getMillisecondsUntilExpire } from "../Models/API/DataModel"

/**
 * This hook notifies 10 seconds before given signed urls expire via callback.
 *
 * @param signedUrls signed urls to monitor
 * @param refresh callback function to refresh signed urls. called 10 seconds before urls expire.
 */
export function useSignedUrlExpiryMonitoring(
    signedUrls: string[],
    refresh: () => void
) {
    useEffect(() => {
        // to not attempt too frequently, set minimum interval for refresh to 10 seconds
        const minIntervalMillis = 10 * 1000
        const expireList = signedUrls.map(getMillisecondsUntilExpire)
        const shouldRefreshAfter = Math.max(
            minIntervalMillis,
            Math.min(...expireList) - 10 * 1000
        )

        if (shouldRefreshAfter <= 0 || expireList.length === 0) {
            return
        }

        const timeout = window.setTimeout(refresh, shouldRefreshAfter)

        return () => window.clearTimeout(timeout)
    }, [signedUrls, refresh])
}
